import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BillerService } from '../../billers/services/biller.service';
import { AnalyticsTransactionProduct } from '../../core/models/analytics-transaction-product.model';
import { PaymentFragment } from '../models/payment-fragment.model';
import { Payment } from '../models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentAnalyticsService {
  private eventName = 'transactionComplete';

  constructor(private billerService: BillerService) {}

  public trackPaymentEvent(payment: Payment): void {
    this.getTransactionProducts(payment).subscribe((products: AnalyticsTransactionProduct[]) => {
      const event = {
        customer: true,
        event: this.eventName,
        transactionAffiliation: '',
        transactionId: payment.id,
        transactionProducts: products,
        transactionShipping: 0,
        transactionTax: payment.commission,
        transactionTotal: payment.liabilitiesAmountToPaySum,
      };

      (window as any).dataLayer.push(event);
    });
  }

  private getTransactionProducts(payment: Payment): Observable<AnalyticsTransactionProduct[]> {
    const productsObservables = payment.paymentFragments.map((pf: PaymentFragment) =>
      this.billerService.getBillerCategories(pf.liability.customerBillerId).pipe(
        map((categories) => {
          const billerCategories = categories && categories.join(',');
          return this.getTransactionProduct(pf, billerCategories);
        }),
      ),
    );

    return combineLatest([...productsObservables]);
  }

  private getTransactionProduct(paymentFragment: PaymentFragment, category: string): AnalyticsTransactionProduct {
    return {
      category,
      name: paymentFragment.liability.billerName,
      price: paymentFragment.amount,
      quantity: 1,
      sku: paymentFragment.liability.title,
    };
  }
}
